"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.shouldCancelAutoPlayOnHover = exports.shouldCancelAutoPlayOnAction = exports.getItemIndexForDotNavigation = exports.checkIsTheLastDotIndex = exports.getDotsNavigationLength = exports.shouldDisableDots = void 0;

var types_1 = require("../types");

function shouldDisableDots(t, e) {
  var o = t || {},
      s = e || {},
      t = s.itemsInSlide,
      e = s.itemsCount,
      s = s.autoWidth;
  return !!o.disableDotsControls || o.controlsStrategy === types_1.ControlsStrategy.RESPONSIVE && !s && t === e;
}

exports.shouldDisableDots = shouldDisableDots, exports.getDotsNavigationLength = function (t, e, o) {
  return void 0 === t && (t = 0), void 0 === e && (e = 1), o ? t : 0 !== Number(e) && Math.ceil(t / e) || 0;
}, exports.checkIsTheLastDotIndex = function (t, e, o) {
  return !e && t === o - 1;
}, exports.getItemIndexForDotNavigation = function (t, e, o, s) {
  return (e ? o - s : t * s) || 0;
}, exports.shouldCancelAutoPlayOnAction = function (t) {
  return void 0 === t && (t = ""), t === types_1.AutoPlayStrategy.ACTION || t === types_1.AutoPlayStrategy.ALL;
}, exports.shouldCancelAutoPlayOnHover = function (t) {
  return void 0 === t && (t = ""), t === types_1.AutoPlayStrategy.DEFAULT || t === types_1.AutoPlayStrategy.ALL;
};